import {
  ApiResponse,
  CreateBookingData,
  Lead,
  CreateApprovelRequestData,
  PaginatedApiResponse,
  ApprovalRequestList,
  ListSort,
} from '../models';
import * as http from './http';
import ApiService from './service';
import { NotificationData, CreateRegisterClient } from '../models/notification';
import { Dict } from '../../models';

export class NotificationService extends ApiService {
  async getNotifications(
    page: number,
    perPage: number
  ): Promise<PaginatedApiResponse<NotificationData> & { unReadCount: number }> {
    const url = `${this.apiDomain}/api/notification?page=${page}&perPage=${perPage}`;

    const resposne = await http.get<
      PaginatedApiResponse<NotificationData> & { unReadCount: number }
    >(url, this.store);

    return {
      ...resposne.data,
    };
  }

  async registerClient(data: CreateRegisterClient) {
    const url = `${this.apiDomain}/api/notification/register-client`;
    const response = await http.post<ApiResponse<NotificationData>>(
      url,
      data,
      this.store
    );
    return response.data?.data;
  }
  async markAllRead() {
    const url = `${this.apiDomain}/api/notification/mark-all-read`;
    const response = await http.put<ApiResponse<NotificationData>>(
      url,
      {},
      this.store
    );
    return response.data?.data;
  }
  async markOneRead(id: string) {
    const url = `${this.apiDomain}/api/notification/${id}/mark-read`;
    const response = await http.put<ApiResponse<NotificationData>>(
      url,
      {},
      this.store
    );
    return response.data?.data;
  }

  public async getEmailReports(
    data: {
      page: number;
      search?: string;
      perPage: number;
      isDeal?: boolean;
      customerId?: string;
    } & ListSort &
      Dict
  ): Promise<PaginatedApiResponse<any> & { lastUpdatedAt: Date }> {
    const url = `${this.apiDomain}/api/notification/email-report`;

    const resposne = await http.post<PaginatedApiResponse<any>>(
      url,
      data,
      this.store
    );
    return { ...resposne.data, lastUpdatedAt: new Date() };
  }
}
